import React from 'react';
import { Link } from 'gatsby';
import { StaticImage, GatsbyImage } from 'gatsby-plugin-image';

import MarkdownSnippet from '../Markdown-Snippet';

function rand(min, max) {
  let randomNum = Math.random() * (max - min) + min;
  return Math.floor(randomNum);
}

const BlogPostItem = ({content, coverImage, tag, title, url}) => {
  let randomImageChoice = rand(1, 4);
  const defaultImage1 = `../../images/placeholder1.png`;
  const defaultImage2 = `../../images/placeholder2.png`;
  const defaultImage3 = `../../images/placeholder3.png`;

  if (coverImage) {
    randomImageChoice = 0;
  }

  return (
    <Link to={url} title={title}>
      {randomImageChoice === 1 && (
        <StaticImage src={defaultImage1} alt={title} />
      )}
      {randomImageChoice === 2 && (
        <StaticImage src={defaultImage2} alt={title} />
      )}
      {randomImageChoice === 3 && (
        <StaticImage src={defaultImage3} alt={title} />
      )}
      {coverImage && (
        <GatsbyImage image={coverImage.localFile.childImageSharp.gatsbyImageData} alt={coverImage.alternativeText} />
      )}
      <p className="mt-8 mb-2 line-clamp-2 text-md font-bold h-14" title={title}>{title}</p>
      <p className="text-orange font-semibold">{tag}</p>
      <MarkdownSnippet className="mt-2 line-clamp-3 text-sm" content={content} />
    </Link>
  );
}

export default BlogPostItem;